"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgSuccessMarkDone = function SvgSuccessMarkDone(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "url(#SuccessMarkDoneLinearGradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.09 12.42 5.057 5.059L18.71 7.88",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SuccessMarkDoneLinearGradient",
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#00B0B6"
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgSuccessMarkDone);
var _default = Memo;
exports["default"] = _default;